import { tmrOperationController } from 'tmr/controllers/operation/operation'
import './inbound.scss'
import templateUrl from './inbound.html'
import icon from './inbound.svg'

/**
 * Inbound Operation route.
 *
 * @namespace routes.OperationInbound
 * @type {TmrRoute}
 */
export const route = {
  name: 'operations.inbound',
  label: 'OPERATIONS.INBOUND.TITLE',
  url: '/inbound',
  resolve: {
    antenna: /*@ngInject*/ ActiveWorkstation => ActiveWorkstation.getAntennas(),
    productImageEnabled: /*@ngInject*/ appConfiguration =>
      appConfiguration['product.image.enabled'],
    /** Retrieves the stock zones of the place of the active user. */
    zones: /*@ngInject*/ (Zone, loggedUser) =>
      Zone.query({
        'place.id': loggedUser.place.id,
        zoneType: 'STOCK',
        orderBy: 'DESCRIPTION',
        asc: true,
      }).$promise,
  },
  component: 'tmrOperationInbound',
  accessControl: 'TmrShippingOperationsLegacyAccessControl',
  data: {
    capabilities: ['Operation.perform', 'Operation.Inbound.perform'],
  },
  weight: 3,
  icon,
}

/**
 * Inbound Operation component
 *
 * @type {ngComponent}
 * @todo document
 */
export const tmrOperationInbound = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrOperationInboundController',
  bindings: {
    antenna: '<',
    zones: '<',
    loggedUser: '<',
    appConfiguration: '<',
  },
}

/**
 * Controller of component {@link tmrOperationInbound}.
 *
 * @type {ngController}
 */
export class tmrOperationInboundController extends tmrOperationController {
  constructor(
    $mdDialog,
    TmrToast,
    TmrMovementHelper,
    TmrOperationHelper,
    debounce,
    Parcel,
    MovementInbound
  ) {
    'ngInject'
    super($mdDialog, TmrToast, TmrMovementHelper, TmrOperationHelper)
    Object.assign(this, { debounce, Parcel, MovementInbound })
  }

  /** Query to find parcels for md-autocomplete. */
  getParcels(searchText) {
    return this.Parcel.findForInbound(searchText, this.loggedUser).$promise
  }

  /**
   * Groups read items by upc + unexpected.
   *
   * @param {object=} details parsed MovementInbound.status response
   */
  buildGroups(details) {
    let expectedItem = this.parcel
      ? this.parcel.parcelItems.map(({ item }) => item)
      : []
    this.itemsByExpectedUpc = this.TmrMovementHelper.groupitemsByExpectedUpc(
      details,
      this.antenna,
      expectedItem
    )
    this.itemsCount = this.TmrMovementHelper.countItems(this.itemsByExpectedUpc)
  }

  initVars() {
    super.initVars()
    this.itemsByExpectedUpc = []
    this.buildGroupsDebounce = this.debounce(150, details =>
      this.buildGroups(details)
    )
    if (this.zones.length == 1) this.zone = this.zones[0]
  }

  onClear() {
    super.onClear()
    this.buildGroups()
  }

  /**
   * Item read event, fired by tmrAntennaControls.
   * Performs MovementInbound.status requests in sequence.
   */
  onItemRead() {
    this.detailsPromise
      .then(() => {
        this.loadingStatus = true
        return this.MovementInbound.status(
          this.zone,
          this.parcel,
          this.antenna.$items,
          this.description
        ).$promise.then(
          details => this.buildGroupsDebounce(details),
          err =>
            this.TmrMovementHelper.statusError(err, this.antenna, () =>
              this.onClear()
            )
        )
      })
      .finally(() => (this.loadingStatus = false))
  }

  onConfirm() {
    super.onConfirm()
    return this.MovementInbound.inbound(
      this.zone,
      this.parcel,
      this.antenna.$items,
      this.description
    )
      .$promise.then(
        () => this.inboundSuccess(),
        err => this.TmrToast.exception(err)
      )
      .finally(() => this.onConfirmed())
  }

  /**
   * MovementInbound.inbound success callback.
   */
  inboundSuccess() {
    this.TmrToast.success(
      'OPERATIONS.INBOUND.SUCCESS',
      { COUNT: this.antenna.$items.length },
      'messageformat'
    )
    this.onClear()
    this.parcel = null
  }
}
